export const SEARCH_INPUT_SOURCING_SUPPLIER_FILTER1 =
  'SEARCH_INPUT_SOURCING_SUPPLIER_FILTER1'
export const SEARCH_OPTION_SOURCING_SUPPLIER_FILTER2 =
  'SEARCH_OPTION_SOURCING_SUPPLIER_FILTER2'
export const SEARCH_OPTION_SOURCING_SUPPLIER_FILTER3 =
  'SEARCH_OPTION_SOURCING_SUPPLIER_FILTER3'
export const SEARCH_OPTION_SOURCING_SUPPLIER_FILTER4 =
  'SEARCH_OPTION_SOURCING_SUPPLIER_FILTER4'
export const SEARCH_OPTION_SOURCING_SUPPLIER_FILTER_EVENT_TYPE =
  'SEARCH_OPTION_SOURCING_SUPPLIER_FILTER_EVENT_TYPE'
